import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyByXRHLbUR3ASK3cY_eWAIEH12lu6cnE6U",
    authDomain: "legaxyvault.com",
    projectId: "legacyvault-0709",
    storageBucket: "legacyvault-0709.firebasestorage.app",
    messagingSenderId: "365917320060",
    appId: "1:365917320060:web:4763d59f1df25d8bd3aaf9",
    measurementId: "G-00YDHD02C9"
};

export const app = initializeApp(firebaseConfig);